import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { isTextMessageEvent } from '../utils/events';
export var MatrixMessageType;

(function (MatrixMessageType) {
  MatrixMessageType["TEXT"] = "m.text";
})(MatrixMessageType || (MatrixMessageType = {}));

export var MatrixMessage = /*#__PURE__*/function () {
  function MatrixMessage(type, sender, content, timestamp) {
    _classCallCheck(this, MatrixMessage);

    this.type = type;
    this.sender = sender;
    this.content = content;
    this.timestamp = timestamp;
  }
  /**
   * Construct a message from a message event
   *
   * @param event
   */


  _createClass(MatrixMessage, null, [{
    key: "from",
    value: function from(event) {
      if (isTextMessageEvent(event)) {
        return new MatrixMessage(event.content.msgtype, event.sender, event.content.body, event.origin_server_ts);
      } // for now only text messages are supported


      return undefined;
    }
  }]);

  return MatrixMessage;
}();